export default __webpack_public_path__ + "static/media/Home-Automation.41d35563.png";